import {   getValidatePersonalDetails } from "../../../helpers/fakebackend_helper";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const reKycValidatePersonalDetailsThunk = createAsyncThunk(
  "reKycValidatePersonalDetailsThunk",
  async ({  token }) => {
    try {
      const response = getValidatePersonalDetails( token);
      return response;
    } catch (error) {
      return error;
    }
  }
);
